export default __webpack_public_path__ + "static/media/Group 1101.3df2feb6.png";